import script from "./UserEditPermission.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEditPermission.vue?vue&type=script&setup=true&lang=js"

import "./UserEditPermission.vue?vue&type=style&index=0&id=6d7ee300&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d7ee300"]])

export default __exports__